import apiClient from './client';

export interface FileRecord {
  id: number;
  entity_type: string;
  entity_id: number;
  file_name: string;
  file_path: string;
  file_size: number;
  mime_type: string;
  category?: string;
  version?: number;
  uploaded_by?: number;
  created_at: string;
  updated_at: string;
}

export const filesApi = {
  getAll: async (entityType?: string, entityId?: number): Promise<FileRecord[]> => {
    const params: any = {};
    if (entityType) params.entity_type = entityType;
    if (entityId) params.entity_id = entityId;
    const response = await apiClient.get<{ success: boolean; data: FileRecord[] }>('/files', { params });
    return response.data.data;
  },
  getById: async (id: number): Promise<FileRecord> => {
    const response = await apiClient.get<{ success: boolean; data: FileRecord }>(`/files/${id}`);
    return response.data.data;
  },
  upload: async (fileData: globalThis.File, entityType: string, entityId: number, category?: string): Promise<FileRecord> => {
    const formData = new FormData();
    formData.append('file', fileData);
    formData.append('entity_type', entityType);
    formData.append('entity_id', entityId.toString());
    if (category) formData.append('category', category);
    
    const response = await apiClient.post<{ success: boolean; data: FileRecord }>('/files/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  },
  download: async (id: number): Promise<Blob> => {
    const response = await apiClient.get(`/files/${id}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/files/${id}`);
  },
};
